import './App.css';
import React from "react";
import Portfolio from "./components/Portfolio";

const App = () => (<Portfolio/>);

export default App;
